/**
 * The two axes every piece of artwork in this system is named by.
 *
 * SHARED ON PURPOSE. Event Setup uses these to define what an event asks for,
 * and the library uses them to label a version that arrived outside any event.
 * Those two lists have to be the same list: a library version labelled
 * "Stacked" cannot answer an event slot called "Vertical / stacked", so a
 * second copy of this vocabulary would quietly break reuse — the one feature
 * that stops a returning sponsor being chased for artwork already on file.
 *
 * Stored as free text rather than an enum, which is deliberate. Real tiers and
 * treatments vary by client, the server accepts any string up to 80
 * characters, and older records may hold values no longer offered here. These
 * are what the interface OFFERS, not what the column permits — so a value
 * outside the list is displayed as it is rather than being hidden or coerced.
 */

export const ORIENTATIONS = ['Horizontal', 'Vertical / stacked', 'Icon / mark only'];

export const TREATMENTS = ['Full color', 'All-white / reversed', 'All-black'];
